import UpdatedStatutes from "./UpdatedStatutes";

export default UpdatedStatutes;
